import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

export const Page = styled.div.withConfig({ componentId: 'sc-1ebfm8n-0' })`
    padding: ${size(4)} 0;

    ${(props) => props.theme.breakpoint.Md} {
        padding: ${size(7)} 0;
    }
`;

interface PageSectionProps {
  $tone?: 'alt';
  $separators?: 'alt' | 'mobile';
}

export const PageSection = styled.div.withConfig({ componentId: 'sc-1ebfm8n-1' })<PageSectionProps>`
    --_spacing: ${size(4)};

    ${(props) => props.theme.breakpoint.Md} {
        --_spacing: ${size(7)};
    }

    & + & {
        margin-top: var(--_spacing);
    }

    ${({ $tone }) =>
      $tone === 'alt'
        ? css`
                  padding: var(--_spacing) 0;
                  background-color: var(--c-bg-alt);
              `
        : undefined}

    ${({ $separators }) =>
      $separators === 'alt'
        ? css`
                  padding: var(--_spacing) 0;
                  border-top: 1px solid var(--c-bg-alt);
                  border-bottom: 1px solid var(--c-bg-alt);
              `
        : $separators === 'mobile'
          ? css`
                  ${(props) => props.theme.breakpoint.LtMd} {
                      padding-bottom: var(--_spacing);
                      border-bottom: ${size(1)} solid var(--c-bg-alt);
                  }
              `
          : undefined}
`;

// Used to pop out element from PageSection (up) on larger screens.
// Useful if the elements children should be overlapping with a hero.
export const PageSectionPopOutMd = styled.div.withConfig({ componentId: 'sc-1ebfm8n-2' })`
    position: relative;
    margin-top: ${size(-8)};
    z-index: 15;

    ${(props) => props.theme.breakpoint.Md} {
        margin-top: ${size(-17)};
        margin-bottom: -100%; // Allows the content to be placed on top of other content on the page
    }
`;

export const PageSearchContainer = styled.div.withConfig({ componentId: 'sc-1ebfm8n-3' })`
    text-align: center;
    max-width: ${size(79)};
    margin: 0 auto;
`;
